<script>
// import axios from "axios";

import Layout from "../../layouts/auth";
import { authMethods, notificationMethods } from "@/state/helpers";
import { mapGetters, mapState } from "vuex";

import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";
// import { mapGetters, mapActions } from "vuex";

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      user_data: {
        email: "",
        password: "",
      },
      emailError: null,
      passError: null,

      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapState("auth", ["status"]),
    ...mapGetters("auth", ["loginStatus", "login_errors"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    ...authMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    LoginFunc() {
      if (this.user_data.email === "") {
        this.emailError = "Email field is required";
        return;
      } else {
        this.emailError = "";
      }
      if (this.user_data.password === "") {
        this.passError = "Password field is required";
        return;
      } else {
        this.passError = "";
      }

      // let user_data = this.user_data;
      this.$store.dispatch("auth/login", this.user_data);
      this.submitted = true;
    },
    resetError() {
      this.emailError = "";
      this.passError = "";
    },
  },
  mounted() {},
};
</script>
<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="row">
                  <div class="col-md-2">
                    <div class="avatar-md profile-user-wid mt-3">
                      <span class="avatar-title rounded-circle bg-light">
                        <img src="@/assets/images/logomain.png" alt height="40" />
                      </span>
                    </div>
                  </div>
                  <div class="col-md-10">
                    <div class="text-primary p-4">
                      <h4 class="text-primary">CLINIC PLUS</h4>
                      <p>Login below with your credentials.</p>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <b-alert v-model="isAuthError" variant="danger" class="mt-3" dismissible>{{
              authError
            }}</b-alert>
            <div v-if="notification.message" :class="'alert ' + notification.type">
              {{ notification.message }}
            </div>
            <b-form class="p-2" @submit.prevent="LoginFunc()">
              <b-form-group
                class="mb-3"
                id="input-group-1"
                label="Email"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  @input="resetError"
                  v-model="user_data.email"
                  type="email"
                  placeholder="Enter email"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                ></b-form-input>
                <div class="text-danger" v-if="emailError">
                  <em>{{ emailError }}</em>
                </div>
              </b-form-group>
              <b-form-group
                class="mb-3"
                id="input-group-2"
                label="Password"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  @input="resetError"
                  v-model="user_data.password"
                  type="password"
                  autocomplete="off"
                  placeholder="Enter password"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                ></b-form-input>
                <div class="text-danger" v-if="passError">
                  <em>{{ passError }}</em>
                </div>
              </b-form-group>
              <b-form-checkbox
                class="form-check"
                id="customControlInline"
                name="checkbox-1"
                value="accepted"
                unchecked-value="not_accepted"
              >
                Remember me
              </b-form-checkbox>
              <div class="mt-3 d-grid">
                <b-button type="submit" variant="primary" class="btn-block"
                  >Log In 
                  <b-spinner
                    v-if="loginStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner
                ></b-button>
              </div>
              <div class="mt-4 text-center">
                <b-alert v-if="login_errors" show variant="danger">
                  <b v-html="login_errors"></b>
<!--                  <b>{{ login_errors }}</b>-->
                </b-alert>
              </div>
              <div class="mt-4 text-center">
                <router-link tag="a" to="/forgot-password" class="text-muted">
                  <i class="mdi mdi-lock me-1"></i> Forgot your password?
                </router-link>
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
        <div class="mt-5 text-center">
          <p>
            © {{ new Date().getFullYear() }} Clinicplus. Developed
            <a target="_blank" href="#"> Nugsoft Technologies</a>
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style lang="scss" module></style>
